import React, {useState} from 'react';
import {Context} from '../context';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export default function Footer(props) {
  const {localeText} = React.useContext(Context);
  const {className} = props;

  const [expanded, setExpanded] = useState(false);

  const content = (
    <React.Fragment>
      <a
        href={localeText('rw_footer_link_1_url', ' ')}
        target='_blank'
        rel='noreferrer'
      >
        {localeText('rw_footer_link_1_text', ' ')}
      </a>
      <a
        href={localeText('rw_footer_link_2_url', ' ')}
        target='_blank'
        rel='noreferrer'
      >
        {localeText('rw_footer_link_2_text', ' ')}
      </a>
      <a
        href={localeText('rw_footer_link_3_url', ' ')}
        target='_blank'
        rel='noreferrer'
      >
        {localeText('rw_footer_link_3_text', ' ')}
      </a>
      <a
        href={localeText('rw_footer_link_4_url', ' ')}
        target='_blank'
        rel='noreferrer'
      >
        {localeText('rw_footer_link_4_text', ' ')}
      </a>
      <a
        href={localeText('rw_footer_link_5_url', ' ')}
        target='_blank'
        rel='noreferrer'
      >
        {localeText('rw_footer_link_5_text', ' ')}
      </a>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <footer className='sm:hidden w-full'>
        <Accordion
          id='footer_accordian'
          sx={{
            position: 'fixed',
            bottom: 0
          }}
          className='w-full'
          onClick={e => {
            setExpanded(prev => !prev);
          }}
          expanded={expanded}
        >
          <AccordionSummary
            aria-controls='panel1a-content'
            id='panel1a-header'
            sx={{
              height: 0,
              '--tw-bg-opacity': 1,
              backgroundColor: 'rgb(249 250 251 / var(--tw-bg-opacity))',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}
            className='bg-gray-50'
          >
            {expanded ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </AccordionSummary>
          <AccordionDetails className='flex flex-col items-center gap-6 text-gray-500 bg-gray-50'>
            {content}
          </AccordionDetails>
        </Accordion>
      </footer>
      <footer
        className={`${className} hidden sm:flex justify-center lg:justify-end items-center p-4 bg-gray-50`}
      >
        <div className='flex gap-8 text-gray-500'>{content}</div>
      </footer>
    </React.Fragment>
  );
}
